var classes = {"badge":"index-module_badge__LFSGS","themed":"index-module_themed__RzZ7w","inverted":"index-module_inverted__kiFh2","rounded":"index-module_rounded__iE1y6"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
